<template>
  <RecordViewWrapper>
    <sdPageHeader title="User">
      <template #buttons>
        <div class="search-container">
          <div class="search-box">
            <span class="search-icon">
              <sdFeatherIcons type="search" size="14" />
            </span>
            <a-input
              @input="handleInputChange"
              v-model:value.trim="formState.searchItem"
              type="text"
              name="recored-search"
              placeholder="Search Here"
              class="search-input"
            />
          </div>
        </div>
      </template>
    </sdPageHeader>

    <Main>
      <a-row :gutter="15">
        <a-col class="w-100" :md="24">
          <sdCards headless>
            <div v-if="isLoading" class="spin">
              <a-spin />
            </div>

            <div v-else>
              <TableWrapper class="table-data-view table-responsive">
                <a-table
                  :pagination="{ pageSize: 10, showSizeChanger: true }"
                  :dataSource="dataSource"
                  :columns="columns"
                >
                  <!-- <template #status="{ text }">
                    <a-tag :color="getStatusColor(text)">
                      {{ text }}
                    </a-tag>
                  </template> -->
                </a-table>
              </TableWrapper>
            </div>
          </sdCards>
        </a-col>
      </a-row>
    </Main>
    <!-- Role Update Modal -->
    <RoleUpdateModal
      v-model:visible="showRoleModal"
      :user-id="currentUser.id"
      :user-name="currentUser.name"
      :user-roles="currentUser.roles"
      :all-roles="allRoles"
      @update:roles="handleRoleUpdate"
    />
  </RecordViewWrapper>
</template>

<script>
import { RecordViewWrapper } from '../../../../components/crud/style';
import { computed, onMounted, reactive, ref } from 'vue';
import { Main, TableWrapper } from '../../../styled';
import { useStore } from 'vuex';
import { Modal, message } from 'ant-design-vue';
import assessmentApi from '@/api/assessment';
import { getItem } from '@/utility/localStorageControl';
import RoleUpdateModal from './modal.vue';
import { createUserActionButtons } from '@/utility/actionButtons';

const ViewPage = {
  name: 'ViewPage',
  components: { RecordViewWrapper, Main, TableWrapper, RoleUpdateModal },
  setup() {
    const { state, dispatch } = useStore();
    const crud = computed(() => state.crud.data);
    const isLoading = computed(() => state.crud.loading);
    const profile = getItem('profile_plnbb');
    const permissions = getItem('permissions');

    const checkPermissions = permission => {
      if (profile.roles[0].name == 'Super Admin') {
        return true;
      }

      return permissions.includes(permission);
    };

    const columns = [
      {
        title: 'Nama',
        dataIndex: 'name',
        key: 'name',
      },
      {
        title: 'NIP',
        dataIndex: 'nip',
        key: 'nip',
      },
      {
        title: 'Email',
        dataIndex: 'email',
        key: 'email',
      },
      {
        title: 'Jabatan',
        dataIndex: 'jabatan',
        key: 'jabatan',
      },
      {
        title: 'Jenjang Jabatan',
        dataIndex: 'jenjang_jabatan',
        key: 'jenjang_jabatan',
      },
      {
        title: 'Role',
        dataIndex: 'roles',
        key: 'roles',
      },
      {
        title: 'Actions',
        dataIndex: 'action',
        key: 'action',
        width: '90px',
      },
    ];

    onMounted(() => {
      dispatch('axiosCrudGetData', 'users-assessment3');
    });

    // Function to generate a random password of specified length using Web Crypto API
    const generateRandomPassword = (length = 8) => {
      const charset = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789!@#$%^&*';
      let password = '';
      const array = new Uint32Array(length);
      window.crypto.getRandomValues(array);

      for (let i = 0; i < length; i++) {
        password += charset[array[i] % charset.length];
      }
      return password;
    };

    const ResetPassword = (id, name) => {
      const newPassword = generateRandomPassword(8);

      Modal.confirm({
        title: 'Konfirmasi',
        content: `Password ${name} akan direset ke: "${newPassword}" ?`,
        okText: 'Reset',
        cancelText: 'Batal',
        onOk: async () => {
          try {
            loading.value = true;

            // Get access token for authorization
            const accessToken = getItem('access_token');
            const headers = {};
            if (accessToken) {
              headers['Authorization'] = `Bearer ${accessToken}`;
            }

            // Make API call to reset password
            await assessmentApi.post(
              'update-user-password',
              {
                userId: id,
                password: newPassword,
                password_confirmation: newPassword,
              },
              { headers },
            );

            message.success(`Password ${name} telah direset ke: ${newPassword}`);

            // Refresh the user list
            dispatch('axiosCrudGetData', 'users-assessment3');
          } catch (error) {
            console.error('Error resetting password:', error);
            message.error(error.response?.data?.message || 'Gagal mereset password');
          } finally {
            loading.value = false;
          }
        },
      });
    };

    const formState = reactive({
      searchItem: '',
    });

    const dataSource = computed(() =>
      crud.value.length
        ? crud.value.map((data, key) => {
            const { name, nip, email, jabatan, jenjang_jabatan, roles } = data;

            const action = createUserActionButtons(data, {
              openRoleModal,
              resetPassword: ResetPassword,
            });

            return {
              key: key + 1,
              name: name || '-',
              nip: nip || '-',
              email: email || '-',
              jabatan: jabatan || '-',
              jenjang_jabatan: jenjang_jabatan || '-',
              roles: Array.isArray(roles) ? roles.map(r => r.name).join(', ') : roles?.name || roles || '-',
              action: action,
            };
          })
        : [],
    );

    const handleSearch = () => {
      dispatch('axiosDataSearch', {
        url: 'users-assessment3',
        filter: formState.searchItem,
      });
    };

    const handleInputChange = () => {
      handleSearch();
    };

    const loading = ref(false);

    const handleDownloadTemplate = event => {
      event.preventDefault();

      dispatch('axiosDownloadTemplate', {
        url: 'download-template-pegawai-assessment',
        fileName: 'Template Import Pegawai Pembinaan Person Grade KEEPInsight.xlsx',
      });
    };

    const handleExport = () => {
      const accessToken = getItem('access_token');
      loading.value = true;

      // Create headers
      const headers = new Headers();
      if (accessToken) {
        headers.append('Authorization', `Bearer ${accessToken}`);
      }
      headers.append('Accept', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');
      headers.append('Content-Type', 'application/json');

      // Make POST request without credentials
      fetch(`${process.env.VUE_APP_API_ASS}/export-pegawai`, {
        method: 'POST',
        headers,
      })
        .then(response => {
          if (!response.ok) throw new Error('Unauthorized');
          return response.blob();
        })
        .then(blob => {
          // Create download link
          const date = new Date();
          const offset = date.getTimezoneOffset();
          date.setMinutes(date.getMinutes() - offset);
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = url;
          a.download = `pegawai_${date
            .toISOString()
            .replace(/[-:T.]/g, '')
            .slice(0, 14)}.xlsx`;
          document.body.appendChild(a);
          a.click();

          // Clean up
          window.URL.revokeObjectURL(url);
          document.body.removeChild(a);
        })
        .catch(error => {
          this.$message.error('Export failed: ' + error.message);
        })
        .finally(() => {
          loading.value = false;
        });
    };

    // Role management state
    const showRoleModal = ref(false);
    const currentUser = ref({
      id: null,
      name: '',
      roles: [],
    });

    // Sample roles - replace with your actual roles from the backend

    const handleRoleUpdate = async event => {
      try {
        loading.value = true;

        // Get access token for authorization
        const accessToken = getItem('access_token');
        const headers = {};
        if (accessToken) {
          headers['Authorization'] = `Bearer ${accessToken}`;
        }

        // Make API call to update user roles
        await assessmentApi.post(
          'update-user-roles',
          {
            userId: event.userId,
            roles: event.roles,
          },
          { headers },
        );

        message.success(`Updated roles for user: ${event.name}`);

        // Refresh the user list
        dispatch('axiosCrudGetData', 'users-assessment3');
      } catch (error) {
        console.error('Error updating user roles:', error);
        message.error(error.response?.data?.message || 'Failed to update user roles');
      } finally {
        loading.value = false;
      }
    };

    const openRoleModal = user => {
      currentUser.value = {
        id: user.id,
        name: user.name,
        roles: user.roles || [],
      };
      showRoleModal.value = true;
    };

    return {
      formState,
      columns,
      isLoading,
      crud,
      dataSource,
      ResetPassword,
      handleSearch,
      handleInputChange,
      handleDownloadTemplate,
      handleExport,
      checkPermissions,
      loading,
      showRoleModal,
      currentUser,
      handleRoleUpdate,
      openRoleModal,
      generateRandomPassword,
    };
  },
};

export default ViewPage;
</script>

<style scoped>
.mr-2 {
  margin-right: 0.5rem;
}

.table-actions a {
  margin-right: 4px;
}

.table-actions a.edit {
  color: #1890ff;
}

.table-actions a.delete {
  color: #ff4d4f;
}

.table-actions a:hover {
  opacity: 0.8;
}

.search-container {
  display: flex;
  align-items: center;
  gap: 8px;
}

.search-select {
  width: 180px;
}

.search-box {
  display: flex;
  align-items: center;
  position: relative;
}

.search-icon {
  position: absolute;
  left: 12px;
  top: 50%;
  transform: translateY(-50%);
  z-index: 1;
}

.search-input {
  padding-left: 35px;
}

.spin {
  animation: spin 1s linear infinite;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>
